<template>
  <div class="account-right fixed-mp-cls">
    <div class="account-breadcrumb">
      <ul>
        <li>
          <router-link :to="{ name: 'home' }">
            {{ _T('Home') }}
            <img src="/images/svg/global/arrow-right-r.svg" alt="" />
          </router-link>
        </li>
        <li>{{ _T('Change Profile') }}</li>
      </ul>
    </div>
    <div class="account-card">
      <div class="account-body profile-media">
        <div class="media">
          <div class="profile-user">
            <img :src="web_user.avatar" alt="" class="img-fluid update_img_0" />
          </div>
          <div class="media-body">
            <h6>{{ _T('User Name') }}</h6>
            <h4>{{ web_user.name }}</h4>
          </div>
          <a
            href="javascript:void(0)"
            class="btn-outline-tertiary btn"
            data-toggle="modal"
            @click="$bvModal.show('change-profile')"
            >{{ _T('Edit') }}</a
          >
        </div>
        <div class="media">
          <img src="/images/svg/account/email.svg" alt="" />
          <div class="media-body">
            <h6>{{ _T('Email address') }}</h6>
            <h4>{{ web_user.email }}</h4>
          </div>
          <a
            href="#"
            class="btn-outline-tertiary btn"
            data-toggle="modal"
            @click="$bvModal.show('change-email')"
            >{{ _T('Edit') }}</a
          >
        </div>
        <div class="media">
          <img src="/images/svg/account/phone.svg" alt="" />
          <div class="media-body">
            <h6>{{ _T('Phone number') }}</h6>
            <h4>{{ web_user.phone_number }}</h4>
          </div>
          <a
            href="#"
            class="btn-outline-tertiary btn"
            data-toggle="modal"
            @click="$bvModal.show('change-number')"
            >{{ _T('Edit') }}</a
          >
        </div>
        <div class="media">
          <img src="/images/svg/account/lock-outline.svg" alt="" />
          <div class="media-body">
            <h6>{{ _T('Password') }}</h6>
            <h4>********</h4>
          </div>
          <a
            href="#"
            class="btn-outline-tertiary btn"
            data-toggle="modal"
            @click="$bvModal.show('change-password')"
            >{{ _T('Edit') }}</a
          >
        </div>
      </div>
    </div>

    <change-name-and-image />
    <change-number />
    <change-password />
    <change-email />
    <verify-email />
    <verify-number />
    <check-email />
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import ChangeNameAndImage from '@/components/Modals/Profile/ChangeNameAndImage'
import ChangeEmail from '@/components/Modals/Profile/ChangeEmail'
import ChangePassword from '@/components/Modals/Profile/ChangePassword'
import ChangeNumber from '@/components/Modals/Profile/ChangeNumber'
import CheckEmail from '@/components/Modals/Profile/CheckEmail'
import VerifyEmail from '@/components/Modals/Profile/VerifyEmail'
import VerifyNumber from '@/components/Modals/Profile/VerifyNumber'

export default {
  name: 'ChangeProfile',
  components: {
    ChangeNameAndImage,
    ChangeEmail,
    ChangePassword,
    ChangeNumber,
    CheckEmail,
    VerifyEmail,
    VerifyNumber,
  },
  computed: {
    ...mapGetters(['is_customer_logged_in', '_T', 'web_user']),
  },
}
</script>

<style lang="scss" scoped>
.body-rtl {
  .account-menu {
    .account-breadcrumb {
      ul {
        padding-left: unset;
        padding-right: 0;
        text-align: right;
      }
    }
  }
}
.account-right {
  .account-breadcrumb {
    ul {
      li {
        line-height: $px17;
        letter-spacing: 0.005em;
        a {
          font-weight: 600;
        }
        img {
          margin-left: $px12;
          margin-right: $px7;
        }
      }
    }
    .breadcrumb-innerpage {
      li {
        font-weight: 600;
      }
    }
  }
  .account-card {
    box-shadow: 0px $px4 $px34 rgba($black, 0.07) !important;
    margin: 18px 0 $px30;
    border-radius: $px10;
    .account-body {
      &.profile-media {
        .media {
          padding: calc(
              #{$px20} + (34 - 20) * ((100vw - #{$px320}) / (1920 - 320))
            )
            calc(#{$px20} + (45 - 20) * ((100vw - #{$px320}) / (1920 - 320)));
          align-items: center;
          .btn {
            padding: 8px
              calc(#{$px20} + (48 - 20) * ((100vw - #{$px320}) / (1920 - 320)));
          }
          + .media {
            border-top: $px1 solid $light-border;
          }
          .profile-user {
            img {
              width: $px40;
              height: $px40;
              border-radius: 100%;
            }
          }
          .media-body {
            margin-left: $px20;
            h6 {
              margin-bottom: $px5;
              line-height: $px14;
              letter-spacing: 0.005em;
              color: rgba($font-color, 0.44);
              font-weight: 500;
            }
            h4 {
              margin-bottom: 0;
              line-height: $px18;
              font-weight: 500;
            }
          }
        }
      }
    }
  }
}
@media (max-width: 767px) {
  .account-right {
    &.fixed-mp-cls {
      padding-bottom: $px30;
    }
  }
}
</style>
